import React, { useCallback, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import { Circle } from '@mui/icons-material';
import SideBarListStyles from '../../styles/SideBarListStyle';
import FloatButton from './FloatButton';
import PlanAddNewPopup from './PlanAddNewPopup';
import { getPlanList, getPlanDetails, showProgress, getPlanAuth } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import useFetchData from '../plan/hooks/useFetchData';
export default function SidebarListPlan(props) {
  const classes = SideBarListStyles();
  const { fetchJourneys } = useFetchData();
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = React.useState(false);
  const planlist = useSelector((state) => state.GetPlanList.planlist);
  const planDetails = useSelector((state) => state.getPlanDetails.plandetails);
  planlist?.sort((a, b) => (b.id > a.id ? 1 : -1));
  const dispatch = useDispatch();

  const handleListItemClick = (event, index, data) => {
    setSelectedIndex(index);
    dispatch(getPlanDetails(data));
    fetchPlanAuth(data.id);
  };
  const addNewPlan = () => {
    setIsAddNewPopupOpen(true);
  };

  const closeAddNewPlan = () => {
    setIsAddNewPopupOpen(false);
  };
  const fetchPlanAuth = async (id) => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.PLAN_AUTHENTICATION.replace('PLAN_ID', id))
      .then((response) => {
        dispatch(getPlanAuth(response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const fetchPlans = useCallback(async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.GET_PLANS, '')
      .then((response) => {
        dispatch(getPlanList('fetch', response));
        handleListItemClick(0, response[0]?.id, response[0] ? response[0] : []);
        dispatch(showProgress(false));
        fetchPlanAuth(response[0]?.id);
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  }, []);
  const value = props.value === undefined ? 0 : props.value;
  const myRef = props.filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  useEffect(() => {
    fetchJourneys();
  }, [fetchJourneys]);

  useEffect(() => {
    if (myRef) {
      myRef[planDetails?.id]?.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [planDetails, props.filterArray]);

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {props.filterArray?.map((data) => {
          const index = data.id;
          return (
            <div key={data.id} className={selectedIndex === index ? classes.highlightItem : ''}>
              <ListItem
                key={data.id}
                ref={myRef[data.id]}
                button
                selected={selectedIndex === index}
                className={classes.listStyling}
                onClick={(event) => handleListItemClick(event, index, data)}
              >
                <ListItemText
                  primary={
                    <div>
                      <p
                        className={`
                          ${selectedIndex === index ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                      >
                        {data.title}
                      </p>
                    </div>
                  }
                  secondary={
                    <div>
                      <div
                        className={
                          selectedIndex === index ? classes.listSubTextSelected : classes.listSubTextNonSelected
                        }
                        style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                      >
                        <div className={classes.listItemId}>ID: {data?.id}</div>
                        <Circle style={{ fontSize: '8px' }} />
                        {data.journeysCount ? `${data.journeysCount} Journeys` : 'No Journeys Yet '}
                        <Circle style={{ fontSize: '8px' }} />
                        {data.storyCount ? `${data.storyCount} Stories` : 'No Stories Yet '}
                      </div>
                    </div>
                  }
                />
              </ListItem>
            </div>
          );
        })}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={3} onAddNewPlan={addNewPlan} />
      {isAddNewPopupOpen && (
        <PlanAddNewPopup open close={closeAddNewPlan} add handleClick={handleListItemClick} type="Journey" />
      )}
    </div>
  );
}
